module.exports = __webpack_public_path__ + "media/hl.54a38e24.mp4";